import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { Hero } from '@/components/home/Hero';
import { EditorialMarquee } from '@/components/home/Marquee';
import { Chapters } from '@/components/home/Chapters';
import { Featured } from '@/components/home/Featured';

export default function Landing() {
    return (
        <div className="min-h-screen bg-paper text-ink" data-testid="landing-page">
            <div className="noise-overlay" aria-hidden="true" />
            <Header />
            <main>
                <Hero />
                <EditorialMarquee />
                <Chapters />
                <Featured />
            </main>
            <Footer />
        </div>
    );
}
